import { createContext } from 'react';

import type { SavedPaymentMethodContent } from 'src/app/pages/promote/shared/types';
import type { PaymentType } from 'src/app/shared/utils/payments';

export type AvailablePaymentMethodsState = {
	paymentMethods: PaymentType[];
	savedPaymentMethods: SavedPaymentMethodContent[];
};

export const AvailablePaymentMethodsContext = createContext<AvailablePaymentMethodsState>({
	paymentMethods: [],
	savedPaymentMethods: [],
});
